import { useEffect } from "react";
import "./App.css";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HeroesWantedPopup from "./components/HeroesWantedPopup";
import Navigation from "./components/Navigation";
import { useHashScrollWithOffset } from "./utils/useHashScrollWithOffset";


function App() {
  // useEffect(() => {
  //   if (window.location.hash) {
  //     const id = window.location.hash.replace("#", "");
  //     const el = document.getElementById(id);
  //     if (el) {
  //       const yOffset = -120;
  //       const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

  //       window.scrollTo({ top: y, behavior: "smooth" });
  //     }
  //   }
  // }, []);

  useHashScrollWithOffset("main-nav", 120);

  return (
    <>
      <HeroesWantedPopup />
      <Navigation />
      <div className="text-center font-franklin bg-[#F9F4EC] overflow-x-hidden">
        <section id="inicio">
          <Header />
        </section>

        <ContactForm />

        <section
          id="contacto"
          className="scroll-mt-[120px] md:scroll-mt-[100px]"
        >
          <Footer />
        </section>
      </div>
    </>
  );
}

export default App;
